module.exports = __webpack_public_path__ + "01_glasses_red.76ffa30d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer4/01_glasses_red.png
// module id = 8TwT
// module chunks = 0